"use client";

import { Text } from "@zapier/design-system";
import { useInView } from "react-intersection-observer";

import { ZapCardTemplate } from "src/components/ZapCard";
import { CrossDomainImage } from "./CrossDomainImage";

import styles from "./TemplateLibraryDetailHeader.module.css";
import classNames from "classnames";
import { TemplateLibraryDetailCTAs } from "./TemplateLibraryDetailCTAs";

type TemplateLibraryDetailProps = {
  template: ZapCardTemplate;
  isDraftModeEnabled: boolean;
};

export const TemplateLibraryDetailHeader = ({
  template,
  isDraftModeEnabled,
}: TemplateLibraryDetailProps) => {
  const { ref, inView } = useInView({ threshold: 0.1 });

  const nextImageUrl = (url: string): string =>
    url.includes("ucarecdn.com") ? `${url}-/preview/70` : url;

  const isStickyHeader = !inView;

  return (
    <div ref={ref}>
      <div
        className={
          isStickyHeader
            ? classNames([styles.templateHeader, styles.sticky])
            : styles.templateHeader
        }
      >
        <div className={styles.templateHeaderContent}>
          <div className={styles.titleWrapper}>
            <div className={styles.title}>
              {template.icon ? (
                <div className={styles.iconWrapper}>
                  <CrossDomainImage
                    alt={`${template.name} favicon`}
                    src={nextImageUrl(template.icon.url)}
                    width={isStickyHeader ? 24 : 40}
                    height={isStickyHeader ? 24 : 40}
                  />
                </div>
              ) : null}
              <div className={styles.header}>
                <Text
                  type={isStickyHeader ? "ParagraphHeader3" : "PageHeader"}
                  color="GrayWarm10"
                  tag="h2"
                >
                  {template.name} {isDraftModeEnabled ? "(Draft)" : ""}
                </Text>
              </div>
            </div>
            {!isStickyHeader && (
              <div className={styles.description}>
                <Text type="Body1">{template.description}</Text>
              </div>
            )}
          </div>
          <div className={styles.ctaContainer}>
            <TemplateLibraryDetailCTAs
              template={template}
              buttonSize="medium"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
